module.exports = "pegasus/assets/background-patterns/fall-automotive-theme.jpg";